class FostrLayoutSwitcher extends HTMLElement {
  get type () {
    return this.getAttribute('type')
  }

  constructor () {
    super()

    // Elements
    this.productGrid = this.closest('fostr-product-grid')
    this.button = this.querySelector('button')

    // Events
    this.button.addEventListener('click', this.onButtonClick.bind(this))
  }

  async update () {
    await customElements.whenDefined(this.productGrid.localName)

    if (this.type === this.productGrid.layout) {
      this.classList.add('is-active')
    } else {
      this.classList.remove('is-active')
    }
  }

  onButtonClick (event) {
    // Fail early if this layout if already active
    if (this.type === this.productGrid.layout) return

    this.productGrid.layout = this.type
  }
}

customElements.define('fostr-layout-switcher', FostrLayoutSwitcher)
